export default __webpack_public_path__ + "static/media/notes-icon.55eabbd4.svg";